import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'CONTRACT',
  inside: {
    membership: { get: 'contracts', set: 'contract' },
  },
});
